<template>
    <v-avatar
        size="25px"
        @click="openThumbnail()"
        rounded="0"
        style="cursor: pointer;"
    >
    <v-img
        alt="Avatar"
        :src="this.imageUrl"
    ></v-img>
    </v-avatar>

</template>

<script>
import fb from "@/main";
import { mapState } from "vuex";
import firebase from "firebase/app";

export default {
  name: "SelfieThumbnail",
  props: ["punchDocId"],
  data() {
    return {
        imageUrl: ""
    };
  },
  async created() {
    this.getSelfie();
  },
  methods: {
    openThumbnail() {
        window.open(this.imageUrl,'_blank');
    },
    getSelfie: async function() {
        const getImage = fb.punchesStorage.ref(`${this.punchDocId}/selfie.jpg`);
        this.imageUrl = await getImage.getDownloadURL();
    }
  }
}
</script>